// Lightweight analytics wrapper. Google Analytics (GA4) loads only when a
// measurement ID is configured via REACT_APP_GA_MEASUREMENT_ID. Falls back to
// console logging so events are visible during development.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || !GA_ID) return;
  initialized = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (GA_ID && window.gtag) {
    window.gtag("event", "page_view", { page_path: path });
  }
}

export function trackEvent(name, params = {}) {
  if (GA_ID && window.gtag) {
    window.gtag("event", name, params);
  } else if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.debug("[analytics]", name, params);
  }
}

export const trackCTA = (label, location) => trackEvent("cta_click", { label, location });
export const trackFormSubmit = (form) => {
  trackEvent("form_submit", { form });
  // GA4-recommended conversion event for lead capture / consultation bookings
  trackEvent("generate_lead", { form });
};
export const trackConsultation = () => trackEvent("consultation_request", {});
export const trackBookCall = (location) => trackEvent("book_call", { location });
export const trackFormStart = (form) => trackEvent("form_start", { form });
export const trackEmailClick = (location) => trackEvent("email_click", { location });
export const trackPhoneClick = (location) => trackEvent("phone_click", { location });
export const trackResourceClick = (slug, location) => trackEvent("resource_click", { slug, location });
